export const MANTRAS: Record<string, string> = {
  'personal-development': 'The purpose should be a compass for decision-making.',
  'wellbeing': 'Put your own oxygen mask on first.',
  'prioritisation': 'Fewer, Bigger, Things.',
  'strategy': 'Simplicity is the ultimate sophistication.',
  'feedback': 'Hard on the issue, soft on the person.',
  'codifying': "I can't hear your words because your actions are deafening me.",
  'reviewing': 'Excellence is not an act but a habit.',
  'meetings': "Top teams over-communicate; dysfunctional ones don't communicate.",
  'innovation': 'You need a blend of people who know all the rules and people who know none of them.',
  'getting-to-know': 'Celebrate difference and forge togetherness.',
};
